import UserCentricViewController from '../../../usercentrics-view-controller';
import { UtilityService } from '../../../../../services/utility.service';
import SecondaryAdvancePrivacyViewController, { FieldSelectionStatus } from '../secondary-advance-privacy-view-controller';
import { DataService } from '../../../../../services/utilities/data.service';
const purposeTemplate = require('./templates/purpose-template/purpose-template.hbs');
const stateName = 'secondaryAdvancePurposeView';

export default class SecondaryAdvancePurposeViewController {
    static CONTROLLER_NAME = 'secondaryAdvancePurposeViewController';
    private isVisible: boolean;
    public purposeStatus: IAB.PurposeStatus = {};
    private purposeToggleFields = {};
    private scrollPos = 0;

    constructor(
        public modalScope,
        private utilityService: UtilityService,
        private secondaryAdvanceViewController: SecondaryAdvancePrivacyViewController
    ) {
        this.isVisible = false;
        this.collapseExpandPurpose = this.collapseExpandPurpose.bind(this);
        this.updatePurposeSelectionStatus = this.updatePurposeSelectionStatus.bind(this);
        this.updateAllPurposeSelectionStatus = this.updateAllPurposeSelectionStatus.bind(this);
        this.initializePurposeStatus();
    }

    public initializePurposeStatus(): void {
        this.purposeStatus = this.utilityService.cmpIABService.getIabPurposeStatus();
    }

    public updatePurposeStatus(purposeStatus: IAB.PurposeStatus): void {
        this.purposeStatus = JSON.parse(JSON.stringify(purposeStatus));
    }

    private setState() {
        this.modalScope.changeState(stateName);
    }

    private collapseExpandPurpose(purpose: IAB.Purpose, viewController: SecondaryAdvancePrivacyViewController): void {
        this.purposeToggleFields[purpose.id] = !this.purposeToggleFields[purpose.id];
        viewController.updateView();
    }

    private getViewHTML() {
        return purposeTemplate;
    }

    private getHtml() {
        this.utilityService.developmentLog('getting purpose view');
        const viewHTML: any = this.getViewHTML();
        const selectionStatus: FieldSelectionStatus = this.secondaryAdvanceViewController.getExternalFieldSelectionStatus(this.utilityService.cmpIABService.purposes, this.purposeStatus, 'id');
        const viewData = {
            allSelected: selectionStatus === FieldSelectionStatus.AllSelected,
            allStatusesIntermediate: selectionStatus === FieldSelectionStatus.SomeSelected,
            icons: UserCentricViewController.icons,
            purposes: this.utilityService.cmpIABService.purposes,
            purposeStatus: this.purposeStatus,
            purposeToggleFields: this.purposeToggleFields,
            settings: this.utilityService.settingsService.settings
        };
        this.utilityService.developmentLog('got purpose view');
        return viewHTML(viewData);
    }

    private setScrollPosition() {
        const scrollDiv = document.getElementById('myTabContent');
        this.scrollPos = scrollDiv.scrollTop;
    }

    private getScrollPosition() {
        const scrollDiv = document.getElementById('myTabContent');
        scrollDiv.scrollTop = this.scrollPos;
    }

    public initHandling() {
        this.utilityService.developmentLog('initializing purpose view');

        if (!this.isVisible) {
            return;
        }
        this.utilityService.cmpIABService.purposes.forEach((purpose: IAB.Purpose) => {
            const toggleSelector: string = `#uc-purpose-click-${purpose.id}`;
            this.registerClickEvent(toggleSelector, purpose, this.collapseExpandPurpose);

            const checkboxSelector: string = `#uc-btn-toggle-purpose-${purpose.id}-modal`;
            this.registerClickEvent(checkboxSelector, purpose, this.updatePurposeSelectionStatus);
        });

        const checkAllSelector: string = '#uc-btn-toggle-purpose-select-all';
        this.registerClickEvent(checkAllSelector, this.utilityService.cmpIABService.purposes, this.updateAllPurposeSelectionStatus);
        this.getScrollPosition();
    }

    private registerClickEvent(selector, argmuent, callback): void {
        const element = this.modalScope.getModalWrapperElement().querySelector(selector);
        if (element && argmuent) {
            element.onclick = (event: any) => {
                event.preventDefault();
                event.stopPropagation();
                this.setScrollPosition();
                callback(argmuent, this.secondaryAdvanceViewController);
            };
        }
    }

    private updateAllPurposeSelectionStatus(purposes: IAB.Purpose[], viewController: SecondaryAdvancePrivacyViewController): void {
        const allSelected: boolean = viewController.getExternalFieldSelectionStatus(this.utilityService.cmpIABService.purposes, this.purposeStatus, 'id') === FieldSelectionStatus.AllSelected;
        purposes.forEach(purpose => this.purposeStatus[purpose.id] = !allSelected);
        viewController.updateView();
    }

    private updatePurposeSelectionStatus(purpose: IAB.Purpose, viewController: SecondaryAdvancePrivacyViewController): void {
        const selectedPurpose: IAB.Purpose = this.utilityService.cmpIABService.purposes.find(item => item.id === purpose.id);
        this.purposeStatus[purpose.id] = !this.purposeStatus[purpose.id];
        viewController.updateView();
    }

    public set visible(visible) {
        this.isVisible = visible;
    }

    public get visible() {
        return this.isVisible;
    }

    public get htmlString(): string {
        if (this.isVisible) {
            return this.getHtml();
        }
        return '';
    }
}
